import axios from "axios";
import {Base_URL} from "../url";

export const fetchAdvanceApprovalData = async () => {
    try {
      const response = await axios.get(`${Base_URL}/AdvanceReq/AdvanceApprovalData`);
      // Return the data in the expected format
      return response.data || [];
    } catch (error) {
      console.error("Error fetching advance approval data:", error);
      throw error;
    }
};
  
export const sendAdvanceApprovalRequest = async (advanceReqId, approvalStatus, createdBy) => {
    try {
      await axios.put(`${Base_URL}/AdvanceReq/UpdateAproval`, {
        advanceReq_id: advanceReqId,
        approvalStatus,
        createdBy
      });
    } catch (error) {
      console.error("Error sending advance approval request:", error);
      throw error;
    }
};